// Baddie Duo isolated staging preview. Remove previewMode before any approved release.
window.NUTRIGAZM_POPUP_V2_CONFIG = {"previewMode": true, "photoUrl": "https://cdn.shopify.com/s/files/1/0664/8751/7434/files/blueberries-censored-original.jpg?v=1792450039", "logoUrl": "data:image/png;base64,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"};
// Approved production release: use real signup outside Shopify design mode.
window.NUTRIGAZM_POPUP_V2_CONFIG.previewMode = false;
(function () {
  const config = {
    discountCode: "RITUAL10",
    endpoint: "",
    photoUrl: "https://nutrigazm.com/cdn/shop/files/about-flavors-daylight.png?v=11963182101180308716",
    logoUrl: "https://cdn.shopify.com/s/files/1/0664/8751/7434/files/image_1.png?v=1778540740",
    shopUrl: "",
    delayMs: 10000,
    mobileDelayMs: 15000,
    scrollPercent: 50,
    dismissedDays: 14,
    previewMode: false,
    ...(window.NUTRIGAZM_POPUP_CONFIG || {}),
    ...(window.NUTRIGAZM_POPUP_V2_CONFIG || {})
  };

  const storagePrefix = "nutrigazmWelcomePopup:v5EmailFirst";
  const submittedKey = `${storagePrefix}:submitted`;
  const dismissedKey = `${storagePrefix}:dismissedUntil`;
  const choiceKey = `${storagePrefix}:choice`;
  const params = new URLSearchParams(window.location.search);
  const forceOpen = params.get("popup") === "1";
  let hasOpened = false;
  let lastFocusedElement = null;
  let submittedEmail = "";

  config.delayMs = Number(config.delayMs || 10000);
  config.mobileDelayMs = Number(config.mobileDelayMs || 15000);
  config.scrollPercent = Number(config.scrollPercent || 50);
  config.dismissedDays = Number(config.dismissedDays || 14);
  config.previewMode = Boolean(config.previewMode || window.Shopify?.designMode);

  const goals = {
    label: {
      title: "Clean, simple ingredients",
      hook: "Start with all three, then choose your favorite.",
      body: "The Variety Starter Pack lets you try Strawberry Cream, Blueberry Bliss, and Dark Chocolate in travel-size bags before choosing a full-size ritual.",
      property: "clean_label_protein",
      productName: "Variety Starter Pack",
      productPath: "/products/variety-starter-pack",
      photoUrl: "https://cdn.shopify.com/s/files/1/0664/8751/7434/files/Starter-Pack-3-High-Res.png?v=1783637250"
    },
    beauty: {
      title: "A beauty-supporting ritual",
      hook: "Meet your Strawberry Cream match.",
      body: "Strawberry Cream combines organic hemp heart protein and organic strawberry in a nutrient-dense whole-food formula.",
      property: "beauty_from_within",
      productName: "Strawberry Cream",
      productPath: "/products/adaptogenic-protein-powder-strawberry-cream",
      photoUrl: "https://cdn.shopify.com/s/files/1/0664/8751/7434/files/NG_SC_FS_RENDER_07-01-26-FRONT.png?v=1783123290"
    },
    energy: {
      title: "Energy + recovery",
      hook: "Meet your Dark Chocolate match.",
      body: "Dark Chocolate delivers 17g of protein per full-size serving in a rich, dessert-inspired whole-food blend.",
      property: "energy_recovery",
      productName: "Dark Chocolate",
      productPath: "/products/superfood-protein-blend",
      photoUrl: "https://cdn.shopify.com/s/files/1/0664/8751/7434/files/NG_DC_FS_RENDER_07-01-26-FRONT.png?v=1783123258"
    },
    taste: {
      title: "A flavor I will look forward to",
      hook: "Meet your Blueberry Bliss match.",
      body: "Blueberry Bliss combines organic hemp heart protein and organic blueberry in an easy, dessert-inspired daily ritual.",
      property: "pleasurable_ritual",
      productName: "Blueberry Bliss",
      productPath: "/products/adaptogenic-protein-powder-blueberry-bliss",
      photoUrl: "https://cdn.shopify.com/s/files/1/0664/8751/7434/files/NG_BB_FS_RENDER_07-01-26-FRONT.png?v=1783123289"
    }
  };

  if (params.get("popup") === "reset") {
    localStorage.removeItem(submittedKey);
    localStorage.removeItem(dismissedKey);
    localStorage.removeItem(choiceKey);
  }

  injectStyles();
  bindPreviewControls();

  if (!forceOpen && !config.previewMode && localStorage.getItem(submittedKey) === "true") {
    return;
  }

  if (!forceOpen && !config.previewMode) {
    const dismissedUntil = Number(localStorage.getItem(dismissedKey) || 0);
    if (dismissedUntil > Date.now()) {
      return;
    }
  }

  buildPopup();
  installTriggers();

  if (forceOpen || config.previewMode) {
    window.setTimeout(() => openPopup("email", "manual"), 100);
  }

  function buildPopup() {
    if (document.querySelector("[data-ng-v2-popup]")) {
      return;
    }

    const wrapper = document.createElement("div");
    wrapper.setAttribute("data-ng-v2-popup", "");
    wrapper.innerHTML = `
      <div class="ng-v2-backdrop" data-ng-v2-close></div>
      <section class="ng-v2-card" role="dialog" aria-modal="true" aria-label="Nutrigazm welcome offer V2">
        <button class="ng-v2-close" type="button" aria-label="Close popup" data-ng-v2-close>&times;</button>
        <div class="ng-v2-grid">
          <div class="ng-v2-photo" aria-hidden="true">
            <div class="ng-v2-photo-badge">Variety Starter Pack</div>
          </div>
          <div class="ng-v2-panel">
            <div class="ng-v2-brand">
              <img class="ng-v2-logo" src="${escapeHtml(config.logoUrl)}" alt="Nutrigazm">
              <span class="ng-v2-wordmark">Nutrigazm</span>
            </div>

            <form class="ng-v2-step is-active" data-ng-v2-step="email">
              
              <h2>Get 10% off.</h2>
              <p class="ng-v2-copy">Your #dailygazm starts here.</p>
              <label class="ng-v2-field">
                <span>First name</span>
                <input type="text" name="firstName" placeholder="Your first name" autocomplete="given-name" maxlength="100">
              </label>
              <label class="ng-v2-field">
                <span>Email address</span>
                <input type="email" name="email" placeholder="you@example.com" autocomplete="email" required>
              </label>
              <button class="ng-v2-submit" type="submit">Get my 10% off</button>
              <p class="ng-v2-fine">By signing up, you agree to receive Nutrigazm emails.<br><span class="ng-v2-fine-bottom">Unsubscribe anytime. <a href="/policies/privacy-policy">Privacy policy</a>.</span></p>
              <p class="ng-v2-status" aria-live="polite"></p>
            </form>

            <div class="ng-v2-step" data-ng-v2-step="reward">
              <p class="ng-v2-offer">Your welcome offer</p>
              <h2>Your 10% code is ready.</h2>
              <p class="ng-v2-copy">Use this code on your first one-time order.</p>
              <button class="ng-v2-code" type="button" data-ng-v2-copy>${escapeHtml(config.discountCode)}</button>
              <a class="ng-v2-shop" data-ng-v2-shop-link href="${escapeHtml(rewardUrlForGoal(null))}">Shop with 10% off</a>
              <p class="ng-v2-status" aria-live="polite"></p>
            </div>
          </div>
        </div>
      </section>
    `;

    document.body.appendChild(wrapper);
    setCompactClass(wrapper);
    wrapper.style.setProperty("--ng-v2-photo-url", `url("${sanitizeCssUrl(config.photoUrl)}")`);
    wrapper.querySelector(".ng-v2-logo")?.addEventListener("error", (event) => {
      event.currentTarget.hidden = true;
    }, { once: true });
    wrapper.addEventListener("click", handlePopupClick);
    wrapper.querySelector("form")?.addEventListener("submit", handleSubmit);
    window.addEventListener("resize", () => setCompactClass(wrapper), { passive: true });
    document.addEventListener("keydown", handleKeydown);
  }

  function bindPreviewControls() {
    document.querySelector("[data-ng-v2-open]")?.addEventListener("click", () => {
      buildPopup();
      openPopup("email", "manual");
    });

    document.querySelector("[data-ng-v2-reset]")?.addEventListener("click", () => {
      localStorage.removeItem(submittedKey);
      localStorage.removeItem(dismissedKey);
      localStorage.removeItem(choiceKey);
      document.querySelector("[data-ng-v2-floating]")?.remove();
      buildPopup();
      openPopup("email", "manual");
    });
  }

  function installTriggers() {
    window.addEventListener("scroll", handleScrollTrigger, { passive: true });
    document.addEventListener("mouseleave", handleExitIntent);
  }

  function handleScrollTrigger() {
    const doc = document.documentElement;
    const scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) {
      return;
    }
    const percent = (window.scrollY / scrollable) * 100;
    if (percent >= config.scrollPercent) {
      openPopup("email", "scroll_depth");
    }
  }

  function handleExitIntent(event) {
    if (window.innerWidth < 900 || event.clientY > 8) {
      return;
    }
    openPopup("email", "exit_intent");
  }

  function handlePopupClick(event) {
    if (event.target.closest("[data-ng-v2-close]")) {
      closePopup();
      // Sticky signup tab removed.
      return;
    }

    const copyTarget = event.target.closest("[data-ng-v2-copy]");
    if (copyTarget) {
      navigator.clipboard?.writeText(config.discountCode).catch(() => null);
      const status = document.querySelector('[data-ng-v2-step="reward"] .ng-v2-status');
      if (status) {
        status.textContent = "Code copied.";
      }
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const email = form.elements.email.value.trim();
    const status = form.querySelector(".ng-v2-status");
    const submit = form.querySelector("button[type='submit']");

    if (submit.disabled || !email || !form.reportValidity()) {
      return;
    }

    submit.disabled = true;
    status.textContent = config.previewMode ? "Preview mode: simulating email capture..." : "Saving your 10% code...";

    try {
      if (config.previewMode) {
        await new Promise((resolve) => window.setTimeout(resolve, 450));
      } else {
        // Public browser subscription API for the existing Nutrigazm Master List.
        // Omit an empty optional name so returning subscribers keep their saved name.
        const firstName = form.elements.firstName.value.trim();
        const profile = {
          email,
          ...(firstName ? { first_name: firstName } : {}),
          properties: {
            $source: "nutrigazm_welcome_popup_v3",
            "Accepts Marketing": true,
            nutrigazm_popup_source: "nutrigazm_welcome_popup_v3",
            nutrigazm_popup_discount_code: config.discountCode,
            nutrigazm_popup_page: window.location.href,
            nutrigazm_popup_version: "v3-email-first",
            nutrigazm_popup_stage: "email_capture",
            nutrigazm_popup_trigger: document.querySelector("[data-ng-v2-popup]")?.dataset.trigger || "unknown",
            nutrigazm_popup_submitted_at: new Date().toISOString()
          },
          subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
        };
        const response = await fetch("https://a.klaviyo.com/client/subscriptions?company_id=TxzRGv", {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            "Accept": "application/vnd.api+json",
            "revision": "2026-07-15"
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "nutrigazm_welcome_popup_v3",
                profile: { data: { type: "profile", attributes: profile } }
              },
              relationships: { list: { data: { type: "list", id: "UZuHPq" } } }
            }
          })
        });
        if (!response.ok) {
          throw new Error("Signup failed.");
        }
      }

      submittedEmail = email;
      localStorage.setItem(submittedKey, "true");
      status.textContent = "";
      showStep("reward");
      focusActiveStep();
    } catch (error) {
      status.textContent = "Something went wrong. Please try again.";
      submit.disabled = false;
    }
  }

  function openPopup(stepName, triggerName) {
    const isExplicitReopen = triggerName === "manual" || triggerName === "floating_reopen";
    if (hasOpened && !config.previewMode && !isExplicitReopen) {
      return;
    }
    if (!config.previewMode && isConsentPending()) {
      return;
    }
    const popup = document.querySelector("[data-ng-v2-popup]");
    if (!popup) {
      return;
    }
    hasOpened = true;
    lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    popup.dataset.trigger = triggerName || "manual";
    bringPopupToFront(popup);
    popup.classList.add("is-open");
    document.body.classList.add("ng-v2-open");
    showStep(stepName);

    window.setTimeout(focusActiveStep, 0);
    window.setTimeout(() => bringPopupToFront(popup), 800);
  }

  function isConsentPending() {
    const customerPrivacy = window.Shopify?.customerPrivacy;
    if (customerPrivacy?.shouldShowBanner?.() === true) {
      return true;
    }
    const selectors = [
      ".shopify-pc__banner__dialog",
      "#shopify-pc__banner",
      "[data-shopify-cookie-banner]"
    ];
    return selectors.some((selector) => Array.from(document.querySelectorAll(selector)).some((element) => {
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.display !== "none"
        && style.visibility !== "hidden"
        && Number.parseFloat(style.opacity || "1") > 0
        && rect.width > 0
        && rect.height > 0;
    }));
  }

  function closePopup() {
    const popup = document.querySelector("[data-ng-v2-popup]");
    popup?.classList.remove("is-open");
    document.body.classList.remove("ng-v2-open");
    const dismissedUntil = Date.now() + config.dismissedDays * 24 * 60 * 60 * 1000;
    localStorage.setItem(dismissedKey, String(dismissedUntil));
    lastFocusedElement?.focus?.();
  }

  function showStep(stepName) {
    document.querySelectorAll("[data-ng-v2-step]").forEach((step) => {
      step.classList.toggle("is-active", step.dataset.ngV2Step === stepName);
    });
  }

  function focusActiveStep() {
    const activeStep = document.querySelector('[data-ng-v2-step].is-active');
    activeStep?.querySelector("button, input, a[href]")?.focus();
  }

  function handleKeydown(event) {
    if (event.key !== "Escape" || !document.querySelector("[data-ng-v2-popup].is-open")) {
      return;
    }
    closePopup();
    // Sticky signup tab removed.
  }

  function renderFloatingButton(label) {
    if (document.querySelector("[data-ng-v2-floating]")) {
      return;
    }
    const button = document.createElement("button");
    button.type = "button";
    button.className = "ng-v2-floating";
    button.setAttribute("data-ng-v2-floating", "");
    button.textContent = label;
    button.addEventListener("click", () => {
      button.remove();
      buildPopup();
      openPopup("email", "floating_reopen");
    });
    document.body.appendChild(button);
  }

  function injectStyles() {
    if (document.querySelector("#ng-v2-popup-styles")) {
      return;
    }
    const style = document.createElement("style");
    style.id = "ng-v2-popup-styles";
    style.textContent = `
      .ng-v2-open { overflow: hidden; }
      [data-ng-v2-popup], [data-ng-v2-popup] * { box-sizing: border-box; }
      [data-ng-v2-popup] {
        --ng-v2-ink: #211716;
        --ng-v2-muted: #6f6360;
        --ng-v2-paper: #fffaf6;
        --ng-v2-cacao: #4a270f;
        --ng-v2-leaf: #536b4b;
        --ng-v2-blush: #f8c4cf;
        --ng-v2-line: rgba(33, 23, 22, 0.13);
        position: fixed;
        inset: 0;
        z-index: 2147483647;
        display: none;
        align-items: center;
        justify-content: center;
        padding: clamp(16px, 5vw, 72px);
        background: rgba(33, 23, 22, 0.38);
        backdrop-filter: blur(7px);
      }
      [data-ng-v2-popup].is-open { display: flex; }
      .ng-v2-backdrop { position: absolute; inset: 0; background: transparent; }
      .ng-v2-card { position: relative; width: min(1080px, 92vw); min-height: 620px; overflow: hidden; border-radius: 8px; background: var(--ng-v2-paper); color: var(--ng-v2-ink); box-shadow: 0 34px 120px rgba(24, 12, 8, 0.38); }
      .ng-v2-close { position: absolute; top: 18px; right: 18px; z-index: 3; display: grid; width: 38px; height: 38px; place-items: center; border: 1px solid var(--ng-v2-line); border-radius: 999px; background: rgba(255, 250, 246, 0.9); color: var(--ng-v2-ink); cursor: pointer; font-size: 24px; line-height: 1; }
      .ng-v2-grid { display: grid; grid-template-columns: 0.9fr 1.1fr; min-height: 620px; }
      .ng-v2-photo { position: relative; min-height: 620px; background: linear-gradient(90deg, rgba(251, 247, 241, 0) 0%, rgba(255, 250, 246, 0.02) 58%, rgba(255, 250, 246, 0.94) 100%), var(--ng-v2-photo-url) center / cover no-repeat; }
      .ng-v2-photo-badge { position: absolute; left: 24px; bottom: 24px; max-width: 220px; padding: 10px 12px; border: 1px solid rgba(255, 250, 246, 0.62); border-radius: 8px; background: rgba(255, 250, 246, 0.84); color: var(--ng-v2-ink); font-size: 0.78rem; font-weight: 900; letter-spacing: 0.08em; text-transform: uppercase; }
      .ng-v2-panel { display: grid; align-content: center; min-width: 0; min-height: 620px; padding: 54px 64px 52px 54px; background: var(--ng-v2-paper); text-align: left; }
      .ng-v2-brand { display: flex; align-items: center; min-height: 38px; margin: 0 0 24px; }
      .ng-v2-logo { display: block; width: 176px; height: auto; }
      .ng-v2-logo[hidden] { display: none; }
      .ng-v2-wordmark { color: var(--ng-v2-ink); font-size: 1.02rem; font-weight: 850; letter-spacing: 0; }
      .ng-v2-logo:not([hidden]) + .ng-v2-wordmark { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); white-space: nowrap; }
      .ng-v2-step { display: none; }
      .ng-v2-step.is-active { display: grid; width: 100%; max-width: 570px; min-width: 0; justify-items: stretch; }
      .ng-v2-offer { display: inline-flex; justify-self: start; margin: 0 0 18px; padding: 8px 11px; border: 1px solid rgba(83, 107, 75, 0.18); border-radius: 999px; background: rgba(83, 107, 75, 0.09); color: var(--ng-v2-leaf); font-size: 0.72rem; font-weight: 950; letter-spacing: 0.08em; text-transform: uppercase; }
      .ng-v2-step h2 { max-width: 560px; margin: 0 0 14px; color: var(--ng-v2-ink); font-family: Georgia, "Times New Roman", serif; font-size: clamp(2.25rem, 4vw, 3.6rem); font-weight: 900; line-height: 0.98; letter-spacing: 0; overflow-wrap: anywhere; }
      .ng-v2-copy { max-width: 510px; margin: 0 0 22px; color: #514846; font-size: 1.02rem; line-height: 1.52; }
      .ng-v2-options { display: grid; gap: 10px; }
      .ng-v2-options button { display: grid; gap: 4px; width: 100%; min-height: 72px; padding: 13px 15px; border: 1px solid rgba(33, 23, 22, 0.15); border-radius: 8px; background: #fff; color: var(--ng-v2-ink); cursor: pointer; font: inherit; text-align: left; transition: border-color 160ms ease, transform 160ms ease, box-shadow 160ms ease; }
      .ng-v2-options button:hover { border-color: rgba(74, 39, 15, 0.45); transform: translateY(-1px); box-shadow: 0 12px 28px rgba(74, 39, 15, 0.08); }
      .ng-v2-options strong { font-size: 0.94rem; font-weight: 950; }
      .ng-v2-options span { color: var(--ng-v2-muted); font-size: 0.84rem; line-height: 1.35; }
      .ng-v2-field { display: grid; min-width: 0; color: var(--ng-v2-ink); font-size: 0; }
      .ng-v2-field input { min-height: 58px; width: 100%; border: 1px solid rgba(33, 23, 22, 0.22); border-radius: 8px; background: #fff; color: var(--ng-v2-ink); font: inherit; font-size: 1rem; padding: 0 17px; }
      .ng-v2-field input::placeholder { color: #8b827f; opacity: 1; }
      .ng-v2-submit, .ng-v2-shop { min-height: 58px; border: 0; border-radius: 8px; background: var(--ng-v2-cacao); color: #fff; cursor: pointer; font: inherit; font-size: 1rem; font-weight: 950; text-align: center; box-shadow: 0 14px 34px rgba(74, 39, 15, 0.2); }
      .ng-v2-submit { margin-top: 10px; }
      .ng-v2-submit:disabled { opacity: 0.7; cursor: wait; }
      .ng-v2-fine { max-width: 500px; margin: 12px 0 0; color: var(--ng-v2-muted); font-size: 0.82rem; line-height: 1.45; }
      .ng-v2-fine a { color: var(--ng-v2-cacao); font-weight: 800; }
      .ng-v2-close:focus-visible, .ng-v2-options button:focus-visible, .ng-v2-field input:focus-visible, .ng-v2-submit:focus-visible, .ng-v2-skip:focus-visible, .ng-v2-code:focus-visible, .ng-v2-shop:focus-visible, .ng-v2-floating:focus-visible { outline: 3px solid #b13f65; outline-offset: 3px; }
      .ng-v2-skip { justify-self: center; margin-top: 12px; padding: 7px 6px; border: 0; background: transparent; color: var(--ng-v2-cacao); cursor: pointer; font: inherit; font-size: 0.9rem; font-weight: 800; text-decoration: underline; text-underline-offset: 3px; }
      .ng-v2-status { min-height: 20px; margin: 12px 0 0; color: var(--ng-v2-muted); font-size: 0.94rem; }
      .ng-v2-code { min-height: 72px; border: 3px dashed rgba(211, 140, 155, 0.8); border-radius: 8px; background: rgba(242, 232, 220, 0.62); color: var(--ng-v2-cacao); cursor: pointer; font-size: 1.7rem; font-weight: 900; letter-spacing: 0.08em; }
      .ng-v2-code::after { content: "Copy"; margin-left: 10px; color: var(--ng-v2-cacao); font-size: 0.95rem; font-weight: 700; letter-spacing: 0; vertical-align: 0.14em; }
      .ng-v2-shop { display: inline-flex; align-items: center; justify-content: center; margin-top: 18px; text-decoration: none; }
      .ng-v2-floating { position: fixed; right: 18px; bottom: 18px; z-index: 2147483600; min-height: 52px; padding: 0 22px; border: 0; border-radius: 8px; background: var(--ng-v2-cacao, #4a270f); color: #fff; box-shadow: 0 16px 40px rgba(20, 12, 10, 0.28); cursor: pointer; font: inherit; font-weight: 950; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) { padding: clamp(14px, 2.4vh, 28px) clamp(18px, 3vw, 42px); }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-card { width: min(1120px, calc(100vw - 48px)); min-height: 0; max-height: calc(100dvh - 32px); overflow: hidden; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-grid { min-height: 0; height: min(760px, calc(100dvh - 32px)); }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-photo { min-height: 0; height: 100%; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-photo-badge { left: 18px; bottom: 18px; padding: 8px 10px; font-size: 0.7rem; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-panel { min-height: 0; max-height: calc(100dvh - 32px); overflow-y: auto; align-content: center; padding: clamp(24px, 3vh, 34px) clamp(34px, 4vw, 50px) clamp(24px, 3vh, 34px); }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-brand { min-height: 30px; margin-bottom: 14px; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-logo { width: 150px; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-offer { margin-bottom: 12px; padding: 7px 10px; font-size: 0.66rem; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-step h2 { margin-bottom: 10px; font-size: clamp(2.15rem, 3vw, 3rem); line-height: 1; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-copy { margin-bottom: 16px; font-size: 0.95rem; line-height: 1.42; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-options { gap: 8px; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-options button { min-height: 58px; padding: 10px 14px; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-options strong { font-size: 0.88rem; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-options span { font-size: 0.78rem; line-height: 1.28; }
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-field input,
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-submit,
      [data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-shop { min-height: 52px; }
      [data-ng-v2-popup].is-compact { inset: 0 auto 0 0; width: 100vw; max-width: 100vw; align-items: flex-start; justify-content: center; padding: 8px 10px; overflow-x: hidden; overflow-y: auto; }
      [data-ng-v2-popup].is-compact .ng-v2-card { width: min(350px, calc(100vw - 20px)); max-width: 350px; min-height: 0; max-height: calc(100dvh - 16px); overflow-y: auto; }
      [data-ng-v2-popup].is-compact .ng-v2-grid { grid-template-columns: 1fr; min-height: 0; }
      [data-ng-v2-popup].is-compact .ng-v2-photo { min-height: 144px; background: linear-gradient(180deg, rgba(251, 247, 241, 0) 0%, rgba(251, 247, 241, 0.08) 48%, rgba(255, 250, 246, 1) 100%), var(--ng-v2-photo-url) center 48% / cover no-repeat; }
      [data-ng-v2-popup].is-compact .ng-v2-photo-badge { display: none; }
      [data-ng-v2-popup].is-compact .ng-v2-panel { min-height: 0; padding: 15px 16px 17px; text-align: center; }
      [data-ng-v2-popup].is-compact .ng-v2-brand { justify-content: center; margin: 0 auto 10px; min-height: 30px; }
      [data-ng-v2-popup].is-compact .ng-v2-logo { width: 144px; }
      [data-ng-v2-popup].is-compact .ng-v2-offer { justify-self: center; margin-bottom: 10px; padding: 6px 9px; font-size: 0.62rem; }
      [data-ng-v2-popup].is-compact .ng-v2-step.is-active { width: 100%; max-width: 100%; }
      [data-ng-v2-popup].is-compact .ng-v2-step h2 { margin-bottom: 8px; font-size: clamp(1.42rem, 6.9vw, 1.9rem); line-height: 1; }
      [data-ng-v2-popup].is-compact .ng-v2-copy { margin: 0 auto 12px; max-width: 300px; font-size: 0.84rem; line-height: 1.34; }
      [data-ng-v2-popup].is-compact .ng-v2-options { gap: 7px; }
      [data-ng-v2-popup].is-compact .ng-v2-options button { min-height: 55px; padding: 9px 10px; text-align: center; }
      [data-ng-v2-popup].is-compact .ng-v2-options strong { font-size: 0.86rem; }
      [data-ng-v2-popup].is-compact .ng-v2-options span { font-size: 0.72rem; line-height: 1.25; }
      [data-ng-v2-popup].is-compact .ng-v2-field input { min-height: 50px; font-size: 1rem; padding: 0 14px; }
      [data-ng-v2-popup].is-compact .ng-v2-submit, [data-ng-v2-popup].is-compact .ng-v2-shop { min-height: 52px; font-size: 1rem; }
      [data-ng-v2-popup].is-compact .ng-v2-skip { margin-top: 9px; font-size: 0.78rem; }
      [data-ng-v2-popup].is-compact .ng-v2-fine { margin: 9px auto 0; font-size: 0.69rem; line-height: 1.3; }
      [data-ng-v2-popup].is-compact .ng-v2-code { min-height: 62px; font-size: 1.35rem; }
      @supports (height: 100svh) {
        [data-ng-v2-popup].is-compact .ng-v2-card { max-height: calc(100svh - 16px); }
      }
    `;
    style.textContent += '\n/* Approved September 9 offer design; use px to avoid theme rem scaling. */\n[data-ng-v2-popup]{padding:16px;font:18px/1.5 Arial,sans-serif}\n[data-ng-v2-popup] .ng-v2-card{width:min(900px,calc(100vw - 32px));min-height:0;max-height:calc(100dvh - 32px);overflow:auto;border-radius:22px;background:#fff8f1;color:#30251f}\n[data-ng-v2-popup] .ng-v2-grid{grid-template-columns:1fr 1fr;min-height:480px;height:auto}\n[data-ng-v2-popup] .ng-v2-photo{min-height:480px;height:100%;background:var(--ng-v2-photo-url) center/cover no-repeat}\n[data-ng-v2-popup] .ng-v2-photo-badge,[data-ng-v2-popup] .ng-v2-brand{display:none}\n[data-ng-v2-popup] .ng-v2-panel{display:block;min-height:0;max-height:none;overflow:visible;padding:76px 38px 50px;background:#fff8f1;align-self:center}\n[data-ng-v2-popup] .ng-v2-step h2{font:600 52px/1.04 Arial,sans-serif;letter-spacing:-2px;color:#30251f;margin:0 0 20px;overflow-wrap:normal}\n[data-ng-v2-popup] .ng-v2-copy{font:19px/1.5 Arial,sans-serif;color:#30251f;margin:0 0 26px}\n[data-ng-v2-popup] .ng-v2-field{display:block;font:16px/1.5 Arial,sans-serif}\n[data-ng-v2-popup] .ng-v2-field span{display:block;margin-bottom:6px}\n[data-ng-v2-popup] .ng-v2-field input{font:18px Arial,sans-serif;height:54px;min-height:54px;padding:12px 14px;border:1px solid #88776c;border-radius:8px}\n[data-ng-v2-popup] .ng-v2-field input::placeholder{font-size:18px!important}\n[data-ng-v2-popup] .ng-v2-submit,[data-ng-v2-popup] .ng-v2-shop{font:600 18px Arial,sans-serif;min-height:54px;background:#dfff00;color:#251e18;border-radius:8px;box-shadow:none;margin-top:12px}\n[data-ng-v2-popup] .ng-v2-fine{font:14px/1.45 Arial,sans-serif;color:#5e5048;margin:15px 0 0}\n[data-ng-v2-popup] .ng-v2-fine a{font-weight:400}\n[data-ng-v2-popup] .ng-v2-close{top:12px;right:12px;width:44px;height:44px;font:28px Arial,sans-serif;background:#fff8f1}\n[data-ng-v2-popup] .ng-v2-status{font:16px/1.4 Arial,sans-serif;margin:14px 0 0;min-height:0}\n[data-ng-v2-popup] .ng-v2-status:empty{display:none}\n[data-ng-v2-popup].is-short-viewport:not(.is-compact){padding:16px}\n[data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-card{width:min(900px,calc(100vw - 32px));max-height:calc(100dvh - 32px);overflow:auto}\n[data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-grid{height:auto;min-height:480px}\n[data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-panel{padding:76px 38px 50px;max-height:none;overflow:visible}\n[data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-step h2{font-size:52px;line-height:1.04;margin-bottom:20px}\n[data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-copy{font-size:19px;line-height:1.5;margin-bottom:26px}\n[data-ng-v2-popup].is-compact{inset:0;width:100%;align-items:center;padding:16px}\n[data-ng-v2-popup].is-compact .ng-v2-card{width:calc(100vw - 32px);max-width:500px;max-height:calc(100dvh - 32px)}\n[data-ng-v2-popup].is-compact .ng-v2-grid{grid-template-columns:1fr;min-height:0;height:auto}\n[data-ng-v2-popup].is-compact .ng-v2-photo{height:170px;min-height:170px;background:var(--ng-v2-photo-url) center 55%/cover no-repeat}\n[data-ng-v2-popup].is-compact .ng-v2-panel{padding:24px;text-align:left;min-height:0}\n[data-ng-v2-popup].is-compact .ng-v2-step h2{font-size:40px;line-height:1.04;margin-bottom:14px}\n[data-ng-v2-popup].is-compact .ng-v2-copy{font-size:18px;line-height:1.5;max-width:none;margin:0 0 18px}\n[data-ng-v2-popup].is-compact .ng-v2-fine{font-size:14px;line-height:1.45;margin:15px 0 0}\n[data-ng-v2-popup].is-compact .ng-v2-field input{font-size:18px}\n[data-ng-v2-popup].is-compact .ng-v2-submit,[data-ng-v2-popup].is-compact .ng-v2-shop{font-size:18px}\n';
    style.textContent += `
[data-ng-v2-popup] .ng-v2-brand{display:flex;min-height:0;margin:0 0 22px;justify-content:flex-start}
[data-ng-v2-popup] .ng-v2-logo{width:170px;height:auto;max-width:100%}
[data-ng-v2-popup] .ng-v2-field + .ng-v2-field{margin-top:12px}
[data-ng-v2-popup] .ng-v2-panel,[data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-panel{padding:48px 38px 36px}
[data-ng-v2-popup].is-compact .ng-v2-panel{padding:22px 24px}
[data-ng-v2-popup].is-compact .ng-v2-photo{height:135px;min-height:135px}
[data-ng-v2-popup].is-compact .ng-v2-brand{display:flex;margin:0 0 18px;justify-content:flex-start}
[data-ng-v2-popup].is-compact .ng-v2-logo{width:150px}
`;
    document.head.appendChild(style);
  }

  function setText(selector, value) {
    const node = document.querySelector(selector);
    if (node) {
      node.textContent = value;
    }
  }

  function setCompactClass(wrapper) {
    const viewportWidth = Math.min(
      Number(window.innerWidth || 9999),
      Number(document.documentElement.clientWidth || 9999)
    );
    const viewportHeight = Number(window.innerHeight || 9999);
    const compact = viewportWidth <= 700;
    const shortViewport = !compact && viewportHeight <= 1060;
    wrapper.classList.toggle("is-compact", compact);
    wrapper.classList.toggle("is-short-viewport", shortViewport);
  }

  function isCompactViewport() {
    const viewportWidth = Math.min(
      Number(window.innerWidth || 9999),
      Number(document.documentElement.clientWidth || 9999)
    );
    return viewportWidth <= 760;
  }

  function bringPopupToFront(popup) {
    if (popup && popup.parentNode === document.body && document.body.lastElementChild !== popup) {
      document.body.appendChild(popup);
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    })[char]);
  }

  function sanitizeCssUrl(value) {
    return String(value || "https://cdn.shopify.com/s/files/1/0664/8751/7434/files/Starter-Pack-3-High-Res.png?v=1783637250").replace(/["\\\n\r]/g, "");
  }

  function rewardUrlForGoal(goal) {
    const redirect = goal?.productPath || "/collections/all";
    const path = `/discount/${encodeURIComponent(config.discountCode)}?redirect=${encodeURIComponent(redirect)}`;
    if (window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost" || window.location.hostname.endsWith(".vercel.app")) {
      return `https://nutrigazm.com${path}`;
    }
    return path;
  }
})();

// Baddie Duo staging presentation.
(function(){var s=document.createElement("style");s.textContent="\n/* Baddie Duo presentation only. Existing capture and dismissal behavior preserved. */\n[data-ng-v2-popup] .ng-v2-card {background:#482b19;color:#fff8f1;border-radius:22px}\n[data-ng-v2-popup] .ng-v2-panel,[data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-panel {background:#482b19;padding:48px 36px 30px}\n[data-ng-v2-popup] .ng-v2-step h2,[data-ng-v2-popup].is-short-viewport:not(.is-compact) .ng-v2-step h2 {color:#edb8c1;font-size:48px;line-height:1.02;letter-spacing:-1.5px}\n[data-ng-v2-popup] .ng-v2-copy,[data-ng-v2-popup] .ng-v2-field,[data-ng-v2-popup] .ng-v2-fine,[data-ng-v2-popup] .ng-v2-fine a,[data-ng-v2-popup] .ng-v2-status {color:#fff8f1}\n[data-ng-v2-popup] .ng-v2-logo {width:150px}\n[data-ng-v2-popup] .ng-v2-wordmark {display:none}\n[data-ng-v2-popup] .ng-v2-photo {background:var(--ng-v2-photo-url) center 40%/cover no-repeat}\n[data-ng-v2-popup] .ng-v2-submit,[data-ng-v2-popup] .ng-v2-shop {background:#edb8c1;color:#482b19;width:100%;min-height:54px}\n[data-ng-v2-popup] .ng-v2-close {background:#482b19;color:#fff8f1;min-width:44px;min-height:44px}\n[data-ng-v2-popup] .ng-v2-field input {background:#fff8f1;color:#482b19;border-color:#edb8c1}\n[data-ng-v2-popup] .ng-v2-code {background:#fff8f1;color:#482b19}\n[data-ng-v2-popup] .ng-v2-fine {font-size:13px;line-height:1.45}\n[data-ng-v2-popup] .ng-v2-fine-bottom {display:inline-block}\n[data-ng-v2-popup] .ng-v2-fine a {display:inline-flex;align-items:center;min-height:44px}\n[data-ng-v2-popup].is-compact .ng-v2-panel {padding:20px 24px 14px}\n[data-ng-v2-popup].is-compact .ng-v2-brand {margin-bottom:16px}\n[data-ng-v2-popup].is-compact .ng-v2-photo {height:150px;min-height:150px;background:var(--ng-v2-photo-url) center 85%/cover no-repeat}\n[data-ng-v2-popup].is-compact .ng-v2-step h2 {font-size:40px;line-height:1.02;letter-spacing:-1.2px;margin-bottom:12px}\n[data-ng-v2-popup].is-compact .ng-v2-copy {font-size:17px;margin-bottom:18px}\n[data-ng-v2-popup].is-compact .ng-v2-fine {font-size:13px;margin-top:12px}\n";document.head.appendChild(s);var h=document.querySelector("[data-ng-v2-step=\"email\"] h2");if(h)h.textContent="Take 10% off, babe.";})();

